'use client'

import type { DatadogClient } from '@/observability'

import { useClientEnv } from './use-client-env'

/**
 * Hook to access the Datadog client from React components.
 *
 * Returns a non-null `DatadogClient`. Browser-only method calls during
 * SSR fall through to the sentinel and report misuse via
 * `reportSSRMisuse`; move such calls into `useEffect` or
 * event handlers.
 *
 * @throws Error if used outside ClientEnvProvider
 *
 * @example
 * ```tsx
 * function CheckoutButton() {
 *   const datadog = useDatadog()
 *
 *   const handleCheckout = () => {
 *     datadog.addAction('checkout_initiated', { cartTotal: 99.99 })
 *   }
 *
 *   return <button onClick={handleCheckout}>Checkout</button>
 * }
 * ```
 */
export function useDatadog(): DatadogClient {
    return useClientEnv().services.datadog
}
